import observeUnscrolled from "./observers/unscrolled";
import observeViewport from "./observers/viewport";
import components from './components';

import popups from "./popups/popups";

import page from "./page";
import $ from 'jquery';


// Event Observers
function observers() {
    observeUnscrolled();
    observeViewport();
}

function checkDimensions() {
}

function init() {
    $(document).ready(function () {
        page.init();

        observers();

        popups.init();

        components.init();
    });
}

init();


